import loadable from '@loadable/component';
const path = './src/models/public-props.ts';
export const manifest = {
  'MobileMenuV2.MenuScreen': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MenuScreenV2Mobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MenuScreenV2Mobile" */
          './menu-screen'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./menu-screen");
            }

            return eval('require.resolve')("./menu-screen");
          }

        }, {
          resolveComponent: mod => mod.MenuScreen
        })
      }
    }
  },
  'MobileMenuV2.ProductScreen': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "ProductScreenV2Mobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "ProductScreenV2Mobile" */
          './product-screen'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./product-screen");
            }

            return eval('require.resolve')("./product-screen");
          }

        }, {
          resolveComponent: mod => mod.ProductScreen
        })
      }
    }
  }
};